<script>
import { ElMessage } from 'element-plus'
import { couponTrack } from './helper'
import { removeUserInfo } from './utils'
import { adsPopupParticipatePost } from '@/services/leafyApi/AdsPopupApi'

export default {
  name: 'NewCouponsDialog',
  props: {
    locale: {
      type: String,
      required: true,
    },
    pageType: {
      type: String,
      default: 'homePage',
      required: true,
    },
    /** 优惠券的渠道，每个渠道不一样 */
    couponInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 默认展示
      showDialog: true,
    }
  },
  computed: {
    promocodes() {
      return (this.couponInfo.itemList || []).map(item => item.batchNo) || []
    },
  },
  methods: {
    closeTicket() {
      this.showDialog = false
    },
    // 先去登录
    toLogin() {
      location.href = `/${this.locale}/passport/signin?pageUrl=${encodeURIComponent(location.href)}`
    },
    /** 普通弹框跳转 */
    handleJumpPop(url) {
      if (!url) { return console.warn('url is Empty') }
      location.href = url
    },
    /**
     * 领取所有优惠券
     */
    getAllCouponsHandler() {
      const token = useCookie('sectoken')
      if (!token.value) {
        return this.toLogin()
      }
      // 直接发放的不请求接口
      if (+this.couponInfo?.receiveType === 1) {
        this.closeTicket()
        // 如果有jumpUrl，则进行跳转
        if (this.couponInfo?.jumpUrl) {
          this.handleJumpPop(this.couponInfo.jumpUrl)
        }
        return
      }
      const trackEvent = (isOk) => {
        couponTrack({
          eventid: 12046,
          action: 'click',
          label: 'PopUp',
          value: {
            PageName: this.pageType,
            PromoCode: this.promocodes,
            PromoCodeState: isOk,
            ButtonName: 'Claim',
            PopUpType: 'PromoCodePOP',
          },
        })
      }
      adsPopupParticipatePost({
        pageType: this.pageType,
        configId: this.couponInfo?.configId,
      }, {
        responseOnlyBody: false,
      }).then((result) => {
        if (result.status === 200) {
          ElMessage.success(result.message)
          trackEvent('1')
          this.closeTicket()
          // 如果有jumpUrl，则进行跳转
          if (this.couponInfo?.jumpUrl) {
            this.handleJumpPop(this.couponInfo.jumpUrl)
          }
        }
        else {
          throw result
        }
      }).catch((err) => {
        console.error('领取失败', err)
        trackEvent('0')
        if (err.status === 401) {
          removeUserInfo()
          this.toLogin()
        }
        else {
          ElMessage.error(err?.message || 'failed')
        }
      })
    },
  },
}
</script>

<template>
  <div v-if="showDialog" class="box">
    <div class="layer" @touchmove.prevent />
    <div
      class="coupons" :style="{
        background: `url(${couponInfo.bgImg}) no-repeat top center / contain, linear-gradient(180deg, #00C868 15.69%, #96E0B8 99.98%)`,
      }"
    >
      <div class="title">
        {{ couponInfo.title }}
      </div>
      <ul class="max-h-[264px] overflow-scroll ticket-list">
        <li v-for="item in couponInfo.itemList" :key="item.batchNo" class="item flex ">
          <div class="item-l mx-[32px]">
            <img class="icon" :src="item.iconPopUrl">
          </div>
          <div class="item-r">
            <p class="tit bold line-clamp-2">
              {{ item.title }}
            </p>
            <p class="f12">
              {{ item.promoTitle }}
            </p>
          </div>
        </li>
      </ul>
      <div class="dilog-bottom">
        <div class="btn font-bold cursor-pointer" @click="getAllCouponsHandler">
          {{ couponInfo.buttonText }}
        </div>
      </div>
      <img src="../../assets/img/coupons/close.png" alt="" class="close cursor-pointer " @click="closeTicket">
    </div>
  </div>
</template>

<style lang="scss" scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;

.bold {
  font-weight: bold;
}

.flex {
  display: flex;
  align-items: center;
}

.f12 {
  font-size: 12px;
}

.box {
  // display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.coupons {
  // position: fixed;
  // top: 50%;
  // left: 50%;
  // right: 40px;
  // transform: translate(-50%, -50%);
  position: relative;
  min-height: 100px;
  width: 390px;
  z-index: 101;
  border-radius: 16px;
  background-position: top right;
  background-repeat: no-repeat;

  .title {
    font-size: 22px;
    color: #faff00;
    // height: 60px;
    line-height: 1.4;
    margin: 16px 0;
    text-align: center;
    font-weight: bold;
  }

  ul {
    padding: 0 16px 16px;
  }

  .item {
    border-image: url('./ticket-popup.png') 6*3 8*3 6*3 102*3 fill;
    border-image-width: 6px 8px 6px 102px;

    border-radius: 8px;

    width: 358px;
    // height: 80px;
    padding: 16px 0;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    &-l {
      display: flex;
      justify-content: center;
      align-items: center;

      .icon {
        width: 32px;
        height: 32px;
        background: no-repeat center center / 100% 100%;
      }

    }

    &-r {
      flex: 1;
      padding: 0 32px;

      .tit {
        font-size: 20px;
      }
    }

    &+.item {
      margin-top: 8px;
    }
  }
}

.dilog-bottom {
  border-radius: 0 0 16px 16px;
  background-color: #fff;
  padding: 16px;
  box-shadow: 0 -2px 6px 0 #0000000d;

  .btn {
    height: 56px;
    line-height: 56px;
    border-radius: 8px;
    width: 100%;
    color: #fff;
    background-color: #00C868;
    font-size: 18px;
    text-align: center;
  }
}

.close {
  position: absolute;
  bottom: -84px;
  height: 28px;
  width: 28px;
  left: 50%;
  margin-left: -14px;
}

.ticket-list {
  overscroll-behavior: none;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
</style>
